import { FC, Fragment, useEffect, useRef, useState } from "react";
import "utils/styles/root.scss";
import "utils/styles/index.scss";
import 'suneditor/dist/css/suneditor.min.css';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigationType, Navigate, Outlet } from "react-router-dom";
import { AdminContainer, AdminWrapper } from "layouts/admin/layout";
import {
	PageAdminLogin, PageAdminHome, PageAdminConfig,
	PageAdminRoleCreate,
	PageAdminRoleUpdate,
	PageAdminRole,
	PageAdminRolePermissionManager,
	PageAdminUser,
	PageAdminUserCreate,
	PageAdminUserUpdate,
	PageAdminPermission,
	PageAdminPermissionCreate,
	PageAdminPermissionUpdate,
	PageAdminPermissionContainer,
	PageAdminUserPermissionManager,


	PageAdminMenu,
	PageAdminMenuCreate,
	PageAdminMenuUpdate,

	PageAdminProfile,
	PageAdminLibrary,
	PageAdminForm,
	PageAdminStatus,
	PageAdminStatusCreate,
	PageAdminStatusUpdate,
	PageAdminWorkflow,
	PageAdminWorkflowCreate,
	PageAdminWorkflowUpdate,

	PageAdminWorkflowStep,
	PageAdminWorkflowStepCreate,
	PageAdminWorkflowStepUpdate,
	PageAdminFormCreate,
	PageAdminFormUpdate,
	PageAdminFormField,
	PageAdminPage, PageAdminPageCreate, PageAdminPageUpdate, PageAdminPageBuilder,

	PageAdminModule,
	PageAdminModuleCreate,
	PageAdminModuleUpdate,

	PageAdminLayout,
	PageAdminLayoutUpdate,
	PageAdminLayoutCreate,
	PageAdminPageBuilderTest,
	PageAdminData,
	PageAdminDataForm,
	PageAdminFormBuilder,
	PageAdminFormStatus,
	PageAdminGroupUser,
	PageAdminGroupUserCreate,
	PageAdminGroupUserUpdate,
	PageAdminGroupUserPermissionManager,
	PageAdminGroupUsers,
	PageAdminFormStep,
	PageAdminGroupFormAccessControll,
	PageAdminRoleFormAccessControll,
	PageAdminUserFormAccessControll,
	PageAdminFormStepConfig,
	PageAdminWorkflowStepProcessFlow,
	PageAdminPageBuilderView_V2,
	PageAdminPageBuilderPreview,
	PageAdminLocaleUpdate,
	PageAdminLocaleCreate,
	PageAdminLocale,
	PageAdminMenuContainer,
} from "layouts";
import axios from "axios";
import { store } from "store";
import { authLogout } from "store/auth";
import { apiAuthCheck, apiGetConfig, apiLocaleOptions, apiPagePublishPages } from "apis";
import { AppMessage, AppScroll } from "components";
import moment from "moment";
import { CONST_DAY_NAMES, CONST_DAY_NAMES_SHORT, CONST_LOCALE_DEFAULT, CONST_MONTH_NAMES, CONST_MONTH_NAMES_SHORT } from "utils";
import { AppNotFound } from "components";
import DataProvider from "layouts/admin/pages/data/Container";
import FilteredSearch from ".test/Search";
import TestNotify from ".test/notifi";
import useAppSelector from "hooks/useAppSelector";
import Check403 from "layouts/admin/layout/Wrapper";

moment.updateLocale("vi", {
	week: { dow: 1 },
	months: CONST_MONTH_NAMES,
	monthsShort: CONST_MONTH_NAMES_SHORT,
	weekdays: CONST_DAY_NAMES,
	weekdaysShort: CONST_DAY_NAMES_SHORT,
});

const App = () => {
	const { token } = useAppSelector(state => state.auth);
	const e401 = useRef<boolean>(false);
	axios.defaults.headers["Content-Type"] = "application/json";
	axios.defaults.headers["Authorization"] = token ? `Bearer ${token}` : null;

	axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
	axios.interceptors.response.use(
		(response) => {
			return response;
		},
		async (error) => {
			let response = error.response || {};
			switch (error.response?.status) {
				case 401:
					if (!e401.current) {
						e401.current = true;
						setTimeout(() => {
							e401.current = false;
						}, 3000)
						if (token) {
							AppMessage.error({
								title: "Thông báo!",
								message: "Phiên làm việc đã hết hạn. Vui lòng đăng nhập lại để tiếp tục!",
							});
						}
					}
					store.dispatch(authLogout());
					break;
				case 403:
					AppMessage.error({
						title: "Thông báo!",
						message: "Bạn không có quyền thao tác. Vui lòng liên hệ quản trị viên!",
					});
					break;
				default:
					AppMessage.error({
						title: "Thông báo lỗi",
						message: response?.data?.message,
					});
					break;
			}
			return response;
		}
	);

	const scrollRef = useRef<HTMLDivElement>(null);
	const [pLoading, setPLoading] = useState<boolean>(true);
	useEffect(() => {
		const int = async () => {
			setPLoading(true);
			await apiAuthCheck();
			await apiGetConfig();
			await apiPagePublishPages();
			await apiLocaleOptions({});
			setPLoading(false)
		}
		int();
	}, [])

	const publishPages = useAppSelector(state => state.page.list.publishPages);
	const locales = useAppSelector(state => state.locale.list.options);

	return (
		<Fragment>
			{/* <AppScroll className="h-screen w-screen" ref={scrollRef}> */}
			<Router>
				<ScrollRestoration />
				<Routes>
					{/* Test */}
					<Route path=".test" element={<Outlet />}>
						<Route path="search" element={<FilteredSearch />} />
						<Route path="notify" element={<TestNotify />} />
					</Route>
					{/* END Test */}
					<Route path="/administrator/login.html" element={<PageAdminLogin />} />

					<Route path="/administrator/page/builder/preview-page.html" element={<PageAdminPageBuilderPreview />} />
					<Route path="/administrator" element={<AdminContainer />}>
						<Route path="" element={<Navigate to="/administrator/dashboard.html" replace />} />
						<Route path="dashboard.html" element={<PageAdminHome />} />
						<Route path="profile.html" element={<PageAdminProfile />} />

						{/* folder-explorer */}
						<Route path="library.html" element={<AdminWrapper permissionCode="admin.library.all"><PageAdminLibrary /></AdminWrapper>} />
						<Route path="config.html" element={<AdminWrapper permissionCode="admin.config.all"><PageAdminConfig /></AdminWrapper>} />

						{/* Ngôn ngữ */}
						<Route path="locale.html" element={<AdminWrapper permissionCode="admin.locale.all"><PageAdminLocale /></AdminWrapper>} />
						<Route path="locale/create.html" element={<AdminWrapper permissionCode="admin.locale.create"><PageAdminLocaleCreate /></AdminWrapper>} />
						<Route path="locale/update/:id.html" element={<AdminWrapper permissionCode="admin.locale.update"><PageAdminLocaleUpdate /></AdminWrapper>} />

						{/* Vai trò */}
						<Route path="role.html" element={<AdminWrapper permissionCode="admin.role.all"><PageAdminRole /></AdminWrapper>} />
						<Route path="role/create.html" element={<AdminWrapper permissionCode="admin.role.create"><PageAdminRoleCreate /></AdminWrapper>} />
						<Route path="role/update/:id.html" element={<AdminWrapper permissionCode="admin.role.update"><PageAdminRoleUpdate /></AdminWrapper>} />
						<Route path="role/access-control/:id.html" element={<AdminWrapper permissionCode="admin.permission.user_access_control"><PageAdminRolePermissionManager /></AdminWrapper>} />
						<Route path="role/access-control/form/:roleId.html" element={<AdminWrapper permissionCode="admin.form.user_access_control"><PageAdminRoleFormAccessControll /></AdminWrapper>} />

						{/* Người dùng */}
						<Route path="user.html" element={<AdminWrapper permissionCode="admin.user.all"><PageAdminUser /></AdminWrapper>} />
						<Route path="user/create.html" element={<AdminWrapper permissionCode="admin.user.create"><PageAdminUserCreate /></AdminWrapper>} />
						<Route path="user/update/:id.html" element={<AdminWrapper permissionCode="admin.user.update"><PageAdminUserUpdate /></AdminWrapper>} />
						<Route path="user/access-control/:id.html" element={<AdminWrapper permissionCode="admin.permission.user_access_control"><PageAdminUserPermissionManager /></AdminWrapper>} />
						<Route path="user/access-control/form/:userId.html" element={<AdminWrapper permissionCode="admin.form.user_access_control"><PageAdminUserFormAccessControll /></AdminWrapper>} />

						{/* Nhóm người dùng */}
						<Route path="group-user.html" element={<AdminWrapper permissionCode="admin.group_user.all"><PageAdminGroupUser /></AdminWrapper>} />
						<Route path="group-user/create.html" element={<AdminWrapper permissionCode="admin.group_user.create"><PageAdminGroupUserCreate /></AdminWrapper>} />
						<Route path="group-user/update/:id.html" element={<AdminWrapper permissionCode="admin.group_user.update"><PageAdminGroupUserUpdate /></AdminWrapper>} />
						<Route path="group-user/access-control/:id.html" element={<AdminWrapper permissionCode="admin.permission.user_access_control"><PageAdminGroupUserPermissionManager /></AdminWrapper>} />
						<Route path="group-user/users/:id.html" element={<AdminWrapper permissionCode="admin.group_user.update"><PageAdminGroupUsers /></AdminWrapper>} />
						<Route path="group-user/access-control/form/:groupId.html" element={<AdminWrapper permissionCode="admin.form.user_access_control"><PageAdminGroupFormAccessControll /></AdminWrapper>} />

						{/* Quyền */}
						<Route path="" element={<AdminWrapper permissionCode="admin.permission.all"><PageAdminPermissionContainer /></AdminWrapper>}>
							<Route path="permission.html" element={<AdminWrapper permissionCode="admin.permission.all"><PageAdminPermission /></AdminWrapper>} />
							<Route path="permission/create.html" element={<AdminWrapper permissionCode="admin.permission.create"><PageAdminPermissionCreate /></AdminWrapper>} />
							<Route path="permission/update/:id.html" element={<AdminWrapper permissionCode="admin.permission.update"><PageAdminPermissionUpdate /></AdminWrapper>} />
						</Route>

						{/* Menu */}
						<Route path="" element={<AdminWrapper permissionCode="admin.menu.all"><PageAdminMenuContainer /></AdminWrapper>}>
							<Route path="menu.html" element={<AdminWrapper permissionCode="admin.menu.all"><PageAdminMenu /></AdminWrapper>} />
							<Route path="menu/create.html" element={<AdminWrapper permissionCode="admin.menu.create"><PageAdminMenuCreate /></AdminWrapper>} />
							<Route path="menu/update/:id.html" element={<AdminWrapper permissionCode="admin.menu.update"><PageAdminMenuUpdate /></AdminWrapper>} />
						</Route>

						{/* Trạng thái */}
						<Route path="status.html" element={<AdminWrapper permissionCode="admin.status.all"><PageAdminStatus /></AdminWrapper>} />
						<Route path="status/create.html" element={<AdminWrapper permissionCode="admin.status.create"><PageAdminStatusCreate /></AdminWrapper>} />
						<Route path="status/update/:id.html" element={<AdminWrapper permissionCode="admin.status.update"><PageAdminStatusUpdate /></AdminWrapper>} />

						{/* Quy trình */}
						<Route path="workflow.html" element={<AdminWrapper permissionCode="admin.workflow.all"><PageAdminWorkflow /></AdminWrapper>} />
						<Route path="workflow/create.html" element={<AdminWrapper permissionCode="admin.workflow.create"><PageAdminWorkflowCreate /></AdminWrapper>} />
						<Route path="workflow/update/:id.html" element={<AdminWrapper permissionCode="admin.workflow.update"><PageAdminWorkflowUpdate /></AdminWrapper>} />
						<Route path="workflow/process-flow/:workflowId.html" element={<AdminWrapper permissionCode="admin.workflow.update"><PageAdminWorkflowStepProcessFlow /></AdminWrapper>} />
						<Route path="workflow/step/:workflowId.html" element={<AdminWrapper permissionCode="admin.workflow.update"><PageAdminWorkflowStep /></AdminWrapper>} />
						<Route path="workflow/step/:workflowId/create.html" element={<AdminWrapper permissionCode="admin.workflow.update"><PageAdminWorkflowStepCreate /></AdminWrapper>} />
						<Route path="workflow/step/:workflowId/update/:id.html" element={<AdminWrapper permissionCode="admin.workflow.update"><PageAdminWorkflowStepUpdate /></AdminWrapper>} />

						{/* Form */}
						<Route path="form.html" element={<AdminWrapper permissionCode="admin.form.all"><PageAdminForm /></AdminWrapper>} />
						<Route path="form/create.html" element={<AdminWrapper permissionCode="admin.form.create"><PageAdminFormCreate /></AdminWrapper>} />
						<Route path="form/update/:id.html" element={<AdminWrapper permissionCode="admin.form.update"><PageAdminFormUpdate /></AdminWrapper>} />
						<Route path="form/field/:id.html" element={<AdminWrapper permissionCode="admin.form.update"><PageAdminFormField /></AdminWrapper>} />
						<Route path="form/builder/:id.html" element={<AdminWrapper permissionCode="admin.form.build"><PageAdminFormBuilder /></AdminWrapper>} />
						<Route path="form/:id/status.html" element={<AdminWrapper permissionCode="admin.form.update"><PageAdminFormStatus /></AdminWrapper>} />
						<Route path="form/:id/step.html" element={<AdminWrapper permissionCode="admin.form.update"><PageAdminFormStep /></AdminWrapper>} />
						<Route path="form/:formId/step/config/:stepId.html" element={<AdminWrapper permissionCode="admin.form.update"><PageAdminFormStepConfig /></AdminWrapper>} />

						<Route path="data" element={<DataProvider />}>
							<Route path=":formCode.html" element={<PageAdminData />} />
							<Route path=":formCode/:stepName/:stepId.html" element={<PageAdminDataForm />} />
							<Route path=":formCode/:stepName/:stepId/:id.html" element={<PageAdminDataForm />} />
						</Route>

						{/* Trang */}
						<Route path="page.html" element={<AdminWrapper permissionCode="admin.page.all"><PageAdminPage /></AdminWrapper>} />
						<Route path="page/create.html" element={<AdminWrapper permissionCode="admin.page.create"><PageAdminPageCreate /></AdminWrapper>} />
						<Route path="page/update/:id.html" element={<AdminWrapper permissionCode="admin.page.update"><PageAdminPageUpdate /></AdminWrapper>} />
						<Route path="page/builder/test.html" element={<AdminWrapper permissionCode="admin.page.build"><PageAdminPageBuilderTest /></AdminWrapper>} />
						<Route path="page/builder/:id.html" element={<AdminWrapper permissionCode="admin.page.build"><PageAdminPageBuilder /></AdminWrapper>} />

						{/* Module */}
						<Route path="module.html" element={<AdminWrapper permissionCode="admin.module.all"><PageAdminModule /></AdminWrapper>} />
						<Route path="module/create.html" element={<AdminWrapper permissionCode="admin.module.create"><PageAdminModuleCreate /></AdminWrapper>} />
						<Route path="module/update/:id.html" element={<AdminWrapper permissionCode="admin.module.update"><PageAdminModuleUpdate /></AdminWrapper>} />

						{/* Layout */}
						<Route path="layout.html" element={<AdminWrapper permissionCode="admin.layout.all"><PageAdminLayout /></AdminWrapper>} />
						<Route path="layout/create.html" element={<AdminWrapper permissionCode="admin.layout.create"><PageAdminLayoutCreate /></AdminWrapper>} />
						<Route path="layout/update/:id.html" element={<AdminWrapper permissionCode="admin.layout.update"><PageAdminLayoutUpdate /></AdminWrapper>} />

						<Route path="*" element={<AppNotFound homeUrl="/administrator" />} />
					</Route>

					{publishPages.map(page => <Route path={page.url} element={locales.length > 0 ? <RedirectToDefaultLocale /> : <PageAdminPageBuilderView_V2 pageId={page.id} />} />)}
					{locales.length > 0 && publishPages.map(page => <Route path={`/:locale${page.url}`} element={<PageAdminPageBuilderView_V2 pageId={page.id} />} />)}
					<Route path="*" element={<AppNotFound homeUrl="/" loading={pLoading} />} />
				</Routes>
			</Router>
			{/* </AppScroll> */}
		</Fragment>
	);
};
export default App;

const RedirectToDefaultLocale = () => {
	const location = useLocation();
	return <Navigate to={{ ...location, pathname: `/${CONST_LOCALE_DEFAULT}${location.pathname}` }} replace />;
}

const scrollPositions: Record<string, number> = {};

interface ScrollRestorationProps {
	// scrollRef: React.RefObject<HTMLDivElement | null>;
}
const ScrollRestoration: FC<ScrollRestorationProps> = ({ }) => {
	const location = useLocation();
	const navigationType = useNavigationType();

	useEffect(() => {
		if (navigationType === "POP") {
			// Back/Forward: khôi phục scroll
			const pos = scrollPositions[location.key];
			window.scrollTo(0, pos || 0);
		} else {
			// Push/Replace: luôn về đầu
			window.scrollTo(0, 0);
		}

		return () => {
			// Lưu lại scroll position khi rời khỏi trang
			scrollPositions[location.key] = window.scrollY;
		};
	}, [location, navigationType]);

	return null;
}